export default __webpack_public_path__ + "static/Chrishmal-69ed956be3c7ff730afb4f2c11a7d17f.png";